// extracted by mini-css-extract-plugin
module.exports = {"link":"Fl5SH","root":"_2oKeI","title":"_2uwx2","bold":"LSdVQ","list":"_32Zj_","listItem":"QX6-O"};